export function GoldOnlineSection({ type = "Buy" }) {
  const titles = {
    Buy: "Buy 24K Gold Online in the UAE with JustGold",
    Sell: "Sell Gold Online Across the UAE with JustGold",
    Delivery: "Secure Gold Delivery Across the UAE with JustGold",
  };
  return (
    <section className="py-16 px-4 bg-[#F1F5FA]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#192839] leading-tight mb-6">
              {titles[type]}
            </h2>
            
            <p className="text-sm sm:text-base md:text-lg text-[#40566d] mb-4">
              JustGold lets you buy, sell, and own certified{' '}
              <a href="#" className="text-blue-800 underline">
                24K gold online in the UAE
              </a>
              , including Dubai, Abu Dhabi, Sharjah, Ajman, Fujairah, Ras Al Khaimah, and Umm Al Quwain.
            </p>
            
            <p className="text-sm sm:text-base md:text-lg text-[#40566d] mb-4">
              The platform provides{' '}
              <a href="#" className="text-blue-800 underline">
                live gold prices
              </a>
              , secure digital storage, and insured fully trackable delivery across the UAE.
            </p>
          </div>

          {/* Right Map */}
          <div className="relative">
            <img
              src="/buy/uae-map.png"
              alt="UAE Map showing Dubai, Abu Dhabi, Sharjah, Ajman, Fujairah, Ras Al Khaimah, and Umm Al Quwain"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
